@if (!hidden) {
    <ms-outrights-marquee
        [fixture]="fixture"
        [backgroundContainerConfig]="backgroundContainerConfig"
        [globalLinkConfig]="globalLinkConfig"
        [maxSelection]="maxSelection" />
}
